<h2>{{ "organisationSettings.branding.title" | translate }}</h2>
<p>{{ "organisationSettings.branding.description" | translate }}</p>
<div [formGroup]="branding">
  @if (INCLUDE_COLORS) {
    <div>
      <h3>{{ "organisationSettings.branding.colors.title" | translate }}</h3>
      <p>
        {{ "organisationSettings.branding.colors.description" | translate }}
      </p>
      <form (submit)="onSubmitColors()" formGroupName="colors" autocomplete="off">
        <div class="colorPicker">
          <label>{{
            "organisationSettings.branding.colors.primary" | translate
          }}</label>
          <input
            name="Primary Colour"
            type="text"
            [disabled]="branding?.controls?.colors.disabled"
            [colorPicker]="primary"
            (colorPickerChange)="primary = $event"
            (colorPickerClose)="primary = $event"
            [style.backgroundColor]="primary"
            />
        </div>
        <div class="colorPicker">
          <label>{{
            "organisationSettings.branding.colors.fabForeground" | translate
          }}</label>
          <input
            name="Create Button Text"
            type="text"
            [disabled]="branding?.controls?.colors.disabled"
            [colorPicker]="fabForeground"
            (colorPickerChange)="fabForeground = $event"
            (colorPickerClose)="fabForeground = $event"
            [style.backgroundColor]="fabForeground"
            />
        </div>
        <div class="colorPicker">
          <label>{{
            "organisationSettings.branding.colors.fabBackground" | translate
          }}</label>
          <input
            name="Create Button Fill"
            type="text"
            [disabled]="branding?.controls?.colors.disabled"
            [colorPicker]="fabBackground"
            (colorPickerChange)="fabBackground = $event"
            (colorPickerClose)="fabBackground = $event"
            [style.backgroundColor]="fabBackground"
            />
        </div>
        <div class="colorPicker">
          <label>{{
            "organisationSettings.branding.colors.fabShadow" | translate
          }}</label>
          <input
            name="Create Button Shadow"
            type="text"
            [disabled]="branding?.controls?.colors.disabled"
            [colorPicker]="fabShadow"
            (colorPickerChange)="fabShadow = $event"
            (colorPickerClose)="fabShadow = $event"
            [style.backgroundColor]="fabShadow"
            />
        </div>
        <button
          [disabled]="branding?.controls?.colors.disabled"
          color="primary"
          (click)="resetColors()"
          type="button"
          ca-raised-button
          color="warn"
          >
          Reset
        </button>
        <button
          (click)="onSubmitColors()"
          color="primary"
          ca-raised-button
          [disabled]="branding?.controls?.colors.disabled"
          >
          Save
        </button>
      </form>
    </div>
  }
  <h3>Images</h3>
  <form formGroupName="media">
    @if (INCLUDE_PLACEHOLDER) {
      <div>
        <h4>Message Placeholder Logo</h4>
        <p>
          This image is used on message cards for messages without photos. Image
          should be at least 300 pixels wide, rectangular images work best.
        </p>
        <ca-photo-picker
          [disabled]="branding?.controls?.media.disabled"
          class="memoLogo"
          [formControlName]="MEMO_BANNER_IMAGE"
          title="Memo Banner Image"
        ></ca-photo-picker>
        <button
          [disabled]="branding?.controls?.media.disabled"
          color="primary"
          (click)="resetImage(MEMO_BANNER_IMAGE)"
          type="button"
          ca-raised-button
          color="warn"
          >
          Reset
        </button>
        <button
          [disabled]="branding?.controls?.media.disabled"
          (click)="onImageSubmitted(MEMO_BANNER_IMAGE)"
          color="primary"
          ca-raised-button
          >
          Save
        </button>
      </div>
    }
    <h4>App Bar Logo</h4>
    <p>Image should be 300x100px</p>
    <ca-photo-picker
      class="smallLogo"
      [formControlName]="SMALL_LOGO"
      title="App Bar Logo"
    ></ca-photo-picker>
    <button
      [disabled]="branding?.controls?.media?.disabled"
      color="primary"
      (click)="resetImage(SMALL_LOGO)"
      type="button"
      ca-raised-button
      color="warn"
      >
      Reset
    </button>
    <button
      [disabled]="branding?.controls?.media?.disabled"
      (click)="onImageSubmitted(SMALL_LOGO)"
      color="primary"
      ca-raised-button
      >
      Save App Bar Logo
    </button>
    <h4>Menu Background Image</h4>
    <p>Image should be 600x350px</p>
    <ca-photo-picker
      class="background"
      [formControlName]="MENU_BACKGROUND_IMAGE"
      title="Menu Background Image"
    ></ca-photo-picker>
    <button
      [disabled]="branding?.controls.media?.disabled"
      color="primary"
      (click)="resetImage(MENU_BACKGROUND_IMAGE)"
      type="button"
      ca-raised-button
      color="warn"
      >
      Reset
    </button>
    <button
      [disabled]="branding?.controls?.media?.disabled"
      (click)="onImageSubmitted(MENU_BACKGROUND_IMAGE)"
      color="primary"
      ca-raised-button
      >
      Save Menu Background
    </button>
    <h4>Menu Icon</h4>
    <p>Image should be 100x100px</p>
    <ca-photo-picker
      class="icon"
      [formControlName]="LOGO_ICON"
      title="Menu Icon"
    ></ca-photo-picker>
    <button
      [disabled]="branding?.controls?.media?.disabled"
      color="primary"
      (click)="resetImage(LOGO_ICON)"
      type="button"
      ca-raised-button
      color="warn"
      >
      Reset
    </button>
    <button
      [disabled]="branding?.controls?.media?.disabled"
      (click)="onImageSubmitted(LOGO_ICON)"
      color="primary"
      ca-raised-button
      >
      Save Icon
    </button>
  </form>
</div>
